import * as gui from './gui'

gui.gui_init()
